import {useState} from "react";
import {BackupData} from "@dropDesk/domain/entities/ticket/backup/backup_data";

export const useModalBackup = () => {

    const [visibleModalDownloadBackup, setVisibleModalDownloadBackup] = useState<{visible: boolean; backupData:BackupData | null}>({visible: false, backupData:null});
    const [visibleModalStartBackup, setVisibleModalStartBackup] = useState<boolean>(false);

    return {
        visibleModalDownloadBackup, setVisibleModalDownloadBackup,
        visibleModalStartBackup, setVisibleModalStartBackup
    }
}
